import User from '../models/User';

export default class LoginController {
	/*@ngInject;*/
	constructor($scope, $timeout, $interval, $http, $location, $route, $routeParams, $sce, $window, $localStorage) {
		$scope.pages = 'login';
		$scope.registration = $location.search();

		var content	= window.translations,
            customer_id	= window.customer_id,
            tokens = window.tokens,
			register_postcode = (window.register_postcode == 1) ? true : false,
			brand_code = window.brand_code,
            reg_code = window.reg_code,
            terms_of_privacy_document_update = window.terms_privacy_document_update;

		$scope.content = content;

        if ($localStorage.terms_of_privacy_update === undefined) {
            $localStorage.$default({
                terms_of_privacy_update: ""
            });
        }

        $scope.terms_of_privacy_update = ($localStorage.terms_of_privacy_update === terms_of_privacy_document_update);

		this.user = new User();

		if (reg_code !== undefined) {
            $scope.member_id = reg_code.member_id;
            $scope.email = reg_code.email;
        }

		$scope.change_page = (page)=> {
			$scope.registration.reg = 0;

			$scope.pages = page;
		};

		$scope.mailto = (email)=> {
			window.location.href = `mailto:${email}`;
		};

        $('[data-toggle="popover"]').popover({ trigger: "hover"});

        if (register_postcode !== false) {
            $('#main-register-form').css('opacity', '0.5');
            $('#main-register-form button').attr('disabled', 'disabled');
            $('#main-register-form input').each(function(){
                $(this).attr('disabled', 'disabled');
            });

            var inputMemberId = $('input[name="member_id"]'),
                inputPostcode = $('input[name="postcode"]');

            inputMemberId.attr('maxlength', '8');
            inputPostcode.attr('maxlength', '5');

            let user    = this.user,
                count   = 0;

            $('.member_id_postcode').on("keypress keyup blur", function(event){
                $(this).val($(this).val().replace(/[^\d].+/, ""));

                if ((event.which < 48 || event.which > 57)) {
                    event.preventDefault();
                }

                if (inputMemberId.val().length == 8 && inputPostcode.val().length == 5) {
                    if (count == 0) {
                        count += 1;

                        $('.member_id_postcode').attr('disabled','disabled');
                        $('img.spinner').css('visibility', 'visible');

                        let data = {
                            member_id   : inputMemberId.val(),
                            postcode    : inputPostcode.val()
                        };

                        user.checkMembership(data).then((value) => {
                            $('img.spinner').css('visibility', 'hidden');

                            if (value.success) {
                                $('#main-register-form').css('opacity', '1');
                                $('#main-register-form button').removeAttr('disabled');
                                $('#main-register-form input').each(function(){
                                    $(this).removeAttr('disabled');
                                });
                            } else {
                                count = 0;

                                $('.member_id_postcode').removeAttr('disabled');

                                swal({
                                    title 		: content['error-swal-title'],
                                    text 		: value.message,
                                    type 		: 'error'
                                });
                            }
                        });
                    }
                }
            });
        }

		$scope.set_guest_password = ($event)=>{
            var password		= ($scope.password !== "" && $scope.password !== undefined) ? $scope.password : false,
				password_conf	= ($scope.password_conf !== "" && $scope.password_conf !== undefined) ? $scope.password_conf : false,
				tnc 			= ($scope.tnc !== undefined) ? $scope.tnc : false,
				error 			= false,
                url             = '/user/guest-password/'+ customer_id +'/'+ tokens.token +'/'+ window.tokens.token_id,
                valid           = true;

            policies.forEach((value)=> {
                if (!value.status) {
                    valid = false;
                    error = content['registration-health-checker-error'];
                }
            });

            if (!tnc) {
                valid = false;
                error = content['error-accept-terms-conditions'];
            }

            if (!valid) {
                swal({
                    title 		: content['error-swal-title'],
                    text 		: error,
                    type 		: 'error'
                });
			} else {
                $scope.guest_password_load = true;

                var data = {
                    password        : password,
                    password_conf   : password_conf,
                    tnc             : tnc
                };

                this.user.setGuestPassword(data, url).then((value)=>{
                    $timeout(()=>{
                        $scope.guest_password_load = false;
                    }, 100);

                    if (!value.success) {
                        swal({
                            title 		: content['error-swal-title'],
                            text 		: value.error[0],
                            type 		: 'error'
                        });
                    }

                    if (value.success === true) {
                        swal({
                            title 		: content['guest-password-set-title'],
                            text 		: content['guest-password-set-text'],
                            type 		: 'success'
                        }).then(()=>{
                            $window.location.href = '/user/login';
                        });
                    }
                });
			}
		};

		$scope.forgot_password = ($event)=>{
			var form 	= $($event.target),
				input 	= form.find('input[name="email"]'),
				data = {
					email : $scope.forgot_email
				};

			$scope.forgot_password_load = true;

			this.user.forgotPassword(data).then((value)=>{
				$scope.$apply(function(){
					$scope.forgot_password_load = false;
				});

				if (value.success) {
					swal({
						title 		: content['reset-email-sent-title'],
						text 		: content['reset-email-sent-text'],
						type 		: 'success'
					});

					input.val("");
				} else {
					swal({
						title 		: content['error-swal-text'],
						text 		: content['error-occurred'],
						type 		: 'error'
					});
				}
			});
		};

		$scope.login = ($event)=> {
		    let valid = true,
                error = "",
                data = {
		            "username": $scope.username,
                    "password": $scope.password
                };

            if (($scope.username == '' || $scope.username === undefined) ||
                ($scope.password == '' || $scope.password === undefined)) {
		        valid = false;

                error = content['error-fill-all-fields'];
            }

            if (!$scope.terms_of_privacy_update) {
		        data['tc-accept'] = 0;

                if ($scope.tnc !== true) {
                    valid = false;

                    error = content['terms-update-text'];
                } else {
                    data['tc-accept'] = 1;
                }
            }

            if (valid === true) {
                $scope.login_submit_load = true;

                this.user.login(data).then((response)=> {
                    if (response.success) {
                        $localStorage.terms_of_privacy_update = terms_of_privacy_document_update;

                        $window.location.href = '/user/dashboard';
                    } else {
                        $scope.$apply(function() {
                            $scope.login_submit_load = false;
                        });

                        swal({
                            title 		: content['error-swal-title'],
                            html 		: response.error,
                            type 		: 'error'
                        });
                    }
                });
            } else {
                swal({
                    title 		: content['error-swal-title'],
                    html 		: error,
                    type 		: 'error'
                });
            }
        };

		$scope.register = ($event)=> {
			var form 	= $($event.target),
				valid 	= true,
				error 	= "",
				data 	= {
					"tc-accept"			: 0,
					"password"			: $scope.password,
					"password_conf"		: $scope.rpassword,
					"email"				: $scope.email,
					"enroled_identifier": $scope.member_id
				};

			if ($scope.first_name !== undefined) {
				data.first_name = $scope.first_name;
				data.last_name = $scope.last_name;
			}

			if (($scope.member_id == '' || $scope.member_id === undefined) ||
				($scope.email == '' || $scope.email === undefined) ||
				($scope.password == '' || $scope.password === undefined)) {
					valid = false;

					error = content['error-fill-all-fields'];
			}

			if ($scope.tnc !== true) {
				valid = false;

				error = content['error-accept-terms-conditions'];
			}

			policies.forEach((value)=> {
                if (!value.status) {
			        valid = false;

			        error = content['registration-health-checker-error'];
                }
            });

			if (valid === true) {
				$scope.register_submit_load = true;

				data['tc-accept'] = 1;

				this.user.register(data).then((value)=>{
					if (value.success) {
						$window.location.href = '/user/login';
					} else {
                        $scope.$apply(function() {
                            $scope.register_submit_load = false;
                        });

                        swal({
							title 		: content['error-swal-title'],
							html 		: value.error[0],
							type 		: 'error'
						});
					}
				});
			} else {
				swal({
					title 		: content['error-swal-title'],
					text 		: error,
					type 		: 'error'
				});
			}
		};

		$scope.reset_password = ($event)=> {
            var form = $($event.target),
				abs_url = $location.absUrl(),
                url = abs_url.substring(abs_url.indexOf('/user/')),
				data = {
            		password : $scope.password,
					password_conf : $scope.password_conf
				},
                valid = true;

            policies.forEach((value)=> {
                if (!value.status) {
                    valid = false;
                }
            });

            if (!valid) {
                swal({
                    title 		: content['error-swal-title'],
                    text 		: content['registration-health-checker-error'],
                    type 		: 'error'
                });
            } else {
                $scope.reset_password_load = true;

                this.user.resetPassword(data, url).then((value) => {
                    $scope.$apply(function () {
                        $scope.reset_password_load = false;
                    });

                    if (value.success) {
                        $window.location.href = '/user/login';
                    } else {
                        swal({
                            title: content['error-swal-title'],
                            text: value.error[0],
                            type: 'error'
                        });
                    }
                });
            }
		};
	}
}
